import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import i18n from './i18n'
import BootstrapVue from 'bootstrap-vue'
import Croppa from 'vue-croppa'
import ustagePlugins from './ustagePlugin'
import VueScrollTo from 'vue-scrollto'
import VueSocketIO from 'vue-socket.io'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import io from 'socket.io-client'
import underscore from 'vue-underscore';

// var connectionString = io('https://universtage.com', { path: '/rest/socket.io'});
var connectionString = io(process.env.VUE_APP_USTAGE_BASE ? process.env.VUE_APP_USTAGE_BASE.substring(0,process.env.VUE_APP_USTAGE_BASE.indexOf("/rest")) : 'http://localhost:3000', { path: '/rest/socket.io'});

Vue.use(underscore);
Vue.use(VueScrollTo)
Vue.use(ustagePlugins)
Vue.use(BootstrapVue)
Vue.use(Croppa)
Vue.use(new VueSocketIO({
    debug: false,
    connection: connectionString,
    vuex: {
      store,
      actionPrefix: 'SOCKET_',
      mutationPrefix: 'SOCKET_'
    }
}))
Vue.config.productionTip = false

export const app = new Vue({
    router, store, i18n,
    render: h => h(App)
}).$mount('#app')
